import { Injectable } from "@angular/core";
import { ChangePasswordModel } from "@obg/ngx.common/types";
import { CoreHttpClient } from "@obg/ngx.core";
import { Observable } from "rxjs";

import { AccountSettingsConfigService } from "./account-settings.config";

@Injectable({
	providedIn: "root",
})
export class AccountSettingsClient {
	constructor(
		private config: AccountSettingsConfigService,
		private httpClient: CoreHttpClient
	) {}

	changePassword(model: ChangePasswordModel): Observable<object> {
		const authTokenHeader = model.authToken ? { "x-auth-token": model.authToken } : undefined;
		return this.httpClient.patch({
			url: this.config.getChangePasswordEndpoint(),
			data: {
				oldPassword: model.oldPassword,
				newPassword: model.newPassword,
			},
			searchParams: {
				username: model.username,
			},
			headers: { ...authTokenHeader },
		});
	}
}
